import api from './api'

const ticketsApi = config =>
  api({
    ...config,
    baseURL: process.env.SERVER,
  })

export const getQuestions = params =>
  ticketsApi({
    method: 'get',
    url: `/api/crm/tickets/question`,
    params,
  })

export const getUnapprovedTickets = () =>
  ticketsApi({
    method: 'get',
    url: `/api/crm/tickets/unapproved`,
  })

export const getForm = params =>
  ticketsApi({
    method: 'get',
    url: `/api/crm/tickets/form`,
    params,
  })

export const submitForm = data =>
  ticketsApi({
    method: 'post',
    url: `/api/crm/tickets/form`,
    data,
  })

export const sendTicketComment = data =>
  ticketsApi({
    method: 'post',
    url: '/api/crm/tickets/approving/message',
    data,
  })

export const getQuestionsSections = () =>
  ticketsApi({
    method: 'get',
    url: `/api/crm/tickets/questions`,
  })
